import React, { useEffect, useRef } from 'react';
import LandingMainSection from '../../components/pages/landing/sections/main';
import LandingMintSection from '../../components/pages/landing/sections/mint';
import LandingFightSection from '../../components/pages/landing/sections/fight';
import LandingCreamSection from '../../components/pages/landing/sections/cream';
import LandingFooterSection from '../../components/pages/landing/sections/footer';
import { useLocation, useSearchParams } from 'react-router-dom';
import LandingMainSectionCircles from '../../components/pages/landing/circles';
import useWeb3 from '../../contexts/web3';
import useUserData from '../../contexts/userData';
import { useAssets } from '../../contexts/assets';

interface Props {
  market?: boolean;
  hideDownload?: boolean;
}

const LandingPage = ({ market = false, hideDownload = false }: Props) => {
  const { setAppLoading } = useAssets();
  const location = useLocation();
  const prevHash = useRef<string>('');
  const firstLoad = useRef(true);

  const paramsParsed = useRef(false);
  const [params] = useSearchParams();
  const { handleMetamaskClick } = useWeb3();
  const { login } = useUserData();

  useEffect(() => {
    if (firstLoad.current) {
      // prerendering all images
      firstLoad.current = false;
      setAppLoading(true);
      Promise.all(
        Array.from(document.images)
          .filter((img) => !img.complete)
          .map(
            (img) =>
              new Promise((resolve) => {
                img.onload = img.onerror = resolve;
              })
          )
      ).then(() => setAppLoading(false));
    } else {
      const hash = getHash(location.hash);
      if (hash !== prevHash.current) {
        scrollToSection(hash);
        prevHash.current = hash;
      }
    }
  }, [location]);

  useEffect(() => {
    if (!paramsParsed.current) {
      paramsParsed.current = true;
      if (market) {
        const token = params.get('id');
        if (token) {
          const shouldMint = params.get('mint');
          const promo = params.get('code');
          const url = ['/market', `?id=${token}`];
          if (shouldMint === '1') {
            url.push('&mint=1');
          }
          if (promo) {
            url.push(`&code=${promo}`);
          }
          handleMetamaskClick(() => {
            login(url.join(''));
          }, 'login/signup');
        }
      }
    }
  }, [params, market]);

  const getHash = (pureHash): string => {
    try {
      return pureHash.split('#')[1] || '';
    } catch (e) {
      return '';
    }
  };

  const scrollToSection = (hash) => {
    const normalHashes = ['', 'nft', 'gameplay', 'cream'];
    const nestedHashes = ['roadmap', 'team', 'info'];
    if (normalHashes.includes(hash)) {
      scrollToNormal(hash);
    } else if (nestedHashes.includes(hash)) {
      scrollToNested(hash);
    }
  };

  const scrollToNormal = (hash) => {
    let top = 0;
    if (hash !== '') {
      const el = document.getElementById(hash);
      if (el) top = el.offsetTop;
    }
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const scrollToNested = (hash) => {
    const parent = document.getElementById('footer-wrapper');
    const el = document.getElementById(hash);
    if (parent && el) {
      window.scrollTo({
        top: parent.offsetTop + el.offsetTop - 20,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <LandingMainSectionCircles />
      <LandingMainSection hideDownload={hideDownload} />
      <LandingMintSection />
      <LandingFightSection />
      <LandingCreamSection />
      <LandingFooterSection />
    </>
  );
};

export default LandingPage;
